/* Pick a PRODUCT (designs/intake-unified-form.md UF21, reshaped by
   teams-and-products.md TP8): the generic PickOrAdd over the product list,
   PICK-ONLY — products belong to product and other teams (a team may own
   several) and an Admin adds them. Grouped by the team that owns each.
   Optional on an effort: none is honestly "not recorded", never guessed. */
import type { JSX } from "react";
import type { CanonicalTeam } from "../../../shared/canonical-teams";
import type { Product } from "../../../shared/products";
import type { FieldHelp } from "./form-help";
import { PickOrAdd } from "./PickOrAdd";

const UNFILED = "Not filed under a team";

export function ProductPicker({
  label,
  products,
  teams = [],
  value,
  onChange,
  disabled = false,
  help,
}: {
  label: string;
  products: Product[];
  /* to name each product's owning team, the group heading */
  teams?: CanonicalTeam[];
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
  help?: FieldHelp;
}): JSX.Element {
  const teamName = (p: Product): string =>
    p.teamId == null ? UNFILED : (teams.find((t) => t.id === p.teamId)?.name ?? p.teamId);
  /* team groups in name order (unfiled last), products in name order within */
  const ordered = [...products].sort(
    (a, b) =>
      Number(a.teamId == null) - Number(b.teamId == null) ||
      teamName(a).toLowerCase().localeCompare(teamName(b).toLowerCase()) ||
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  );
  return (
    <PickOrAdd
      label={label}
      noun="product"
      items={ordered}
      value={value}
      onChange={onChange}
      disabled={disabled}
      testId="product-picker"
      help={help}
      groupOf={teamName}
    />
  );
}
